export const SEARCH_STOPWORDS = new Set([
  "a", "an", "and", "are", "as", "at", "but", "by", "for", "from", "in", "is", "it",
  "like", "of", "on", "or", "that", "the", "to", "with",
]);

export const MAX_SEARCH_QUERY_LENGTH = 280;

export function normalizeSearchText(value = "") {
  return String(value || "")
    .normalize("NFKD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function clampSearchQuery(value = "", maxLength = MAX_SEARCH_QUERY_LENGTH) {
  const raw = String(value || "");
  return raw.length > maxLength ? raw.slice(0, maxLength) : raw;
}

export function tokenizeSearchText(value = "") {
  return normalizeSearchText(value).split(" ").filter(Boolean);
}

export function meaningfulSearchTokens(value = "") {
  return tokenizeSearchText(value).filter((token) => !SEARCH_STOPWORDS.has(token));
}

// True when the query is the start of the title or of any word in it, so
// "slow hor" finds "Slow Horses". Suggestions and lexical title scoring share it.
export function titleMatchesByPrefix(normalizedTitle = "", normalizedQuery = "") {
  if (!normalizedTitle || !normalizedQuery) return false;
  return ` ${normalizedTitle}`.includes(` ${normalizedQuery}`);
}
